import {payUnifiedorderApi,rechargePayApi} from "../api/order/orderInfo";
import { mul } from "../uni_modules/uview-plus/libs/function/calc";
const toolsActive = import.meta.env.VITE_IMG_PREFIX_URL;
const toolsStatic = import.meta.env.VITE_STATIC_REQUEST_PATH;

/**
 * 消息提示框
 */
const fnShowToast = title => {
    uni.showToast({
        title: title,
        icon: 'none',
        mask: true,
        complete: function () {
            setTimeout(function () {
                uni.hideLoading()
            }, 2000);
        }
    });
}

/**
 * 消息提示框：成功提示
 */
const fnShowSuccessToast = title => {
    uni.showToast({
        title: title,
        icon: 'success',
        mask: true,
        complete: function () {
            setTimeout(function () {
                uni.hideLoading()
            }, 2000);
        }
    });
}
/**
 * 针对订单的微信支付
 * @param {*} orderInfoBo 订单
 * @param {*} callBackSuccess 成功回调
 * @param {*} callBackFail 失败回调
 */
function fnOrderPayByHj(orderInfoBo, callBackSuccess, callBackFail) {
    // 获取openId（需要根据uni-app的存储方式调整）
    var openId = uni.getStorageSync('lifeData').vuex_user.openId;
    let amount = mul(orderInfoBo.otherPayMoney,100);
    let param = {
        notiryUrl: 'https://xapi.qcykang.com/order/hj/wxPayReturn',
        amount: amount,
        openId: openId,
        body: orderInfoBo.orderCode,
        attach: orderInfoBo.id,
        platId: 1
    };
    //统一下单
    payUnifiedorderApi(JSON.stringify(param)).then(res1=>{
        console.log("-----------res1",JSON.stringify(res1))
        let retCode = res1.retCode;
        if (1 == retCode) { //success
            let obj = res1.obj;
            let signType = "MD5";
            let packageStr = obj.prepayId;
            // 使用uni-app的支付接口
            uni.requestPayment({
                timeStamp: obj.timeStamp,
                nonceStr: obj.nonceStr,
                package: packageStr,
                signType: signType,
                paySign: obj.paySign,
                success: function (res) {
                    // 支付成功后的回调函数
                    callBackSuccess(res1);
                },
                fail: function (errorRes) {
                    //失败
                    callBackFail(errorRes);
                }
            });
        } else {
            fnShowErrorToast(res1.retMsg);
        }
    })

}
/**
 * 针对订单的线上支付，调用第三方支付平台
 * @param {*} orderInfoBo 订单
 * @param {*} callBackSuccess 成功回调
 * @param {*} callBackFail 失败回调
 */
function fnOrderPayThirdParty(orderInfoBo, type, callBackSuccess, callBackFail) {
    // 获取openId（需要根据uni-app的存储方式调整）
    var openId = uni.getStorageSync('lifeData').vuex_user.openId;
    // let amount = mul(orderInfoBo.otherPayMoney,100);
	let amount = orderInfoBo.otherPayMoney;
    let param = {
        // notiryUrl: 'https://hh.xiaomecloud.com/order/hj/wxPayReturn',
		notiryUrl: 'https://ykyjk-api.38fulent.com/order/hj/wxPayReturn',
        amount: amount,
        openId: openId,
        body: orderInfoBo.orderCode,
        attach: orderInfoBo.id,
        platId: 1
    };
	if(type == 2){
		param.isZfbPay = 1;
	}
    //统一下单
    payUnifiedorderApi(JSON.stringify(param)).then(res1=>{
        console.log("-----------res1",JSON.stringify(res1))
        let retCode = res1.retCode;
        if (1 == retCode) { //success
			if(type == 1){// 微信支付
				let obj = res1.obj;
				let signType = "MD5";
				let packageStr = obj.prepayId;
				// 使用uni-app的支付接口
				uni.requestPayment({
				    timeStamp: obj.timeStamp,
				    nonceStr: obj.nonceStr,
				    package: packageStr,
				    signType: signType,
				    paySign: obj.paySign,
				    success: function (res) {
				        // 支付成功后的回调函数
				        callBackSuccess(res1);
				    },
				    fail: function (errorRes) {
				        //失败
				        callBackFail(errorRes);
				    }
				});
			}else if(type == 2){// 支付宝支付
				let rcResult = res1.obj.rcResult
				console.log("支付宝H5支付地址："+rcResult)
				let result1 = rcResult.split("location.href=")[1];
				let result2 = result1.split(";</script></body>")[0];
				let result3 = result2.slice(1, -1)
				console.log("-----------------解析后支付宝支付地址："+result3)
				// uni.redirectTo({
				//   url: "/pages/orderSettlement/web_view_page?webViewUrl=" + result3,
				// })
				// #ifdef APP-PLUS
				  plus.runtime.openURL(result3); // 5+ API（旧版）
				  // 或 uni-app API (更推荐)
				  // uni.openExternal({
				  //   url: 'https://www.baidu.com/',
				  //   success: () => {
				  //     console.log('成功打开外部浏览器');
				  //   },
				  //   fail: (err) => {
				  //     console.error('打开失败:', err);
				  //   }
				  // });
				  // #endif
				
				  // #ifdef H5
					location.href = result3;
				  // window.open(result3);
				  // #endif
			}
        } else {
            fnShowErrorToast(res1.retMsg);
        }
    })

}

/**
 * 针对订单的线上支付，调用第三方支付平台
 * @param {*} rechargeBo 充值单
 * @param {*} callBackSuccess 成功回调
 * @param {*} callBackFail 失败回调
 */
function fnOrderPayThirdPartyRecharge(rechargeBo, type, callBackSuccess, callBackFail) {
    // 获取openId（需要根据uni-app的存储方式调整）
    var openId = uni.getStorageSync('lifeData').vuex_user.openId;
    let amount = rechargeBo.otherPayMoney;
    let param = {
        // notiryUrl: 'https://hh.xiaomecloud.com/order/hj/rechargeReturn',
    	notiryUrl: 'https://ykyjk-api.38fulent.com/order/hj/rechargeReturn',
        amount: amount,
        openId: openId,
        body: rechargeBo.orderCode,
        attach: rechargeBo.id,
        platId: 1
    };
    if(type == 2){
    	param.isZfbPay = 1;
    }
    //统一下单
    rechargePayApi(JSON.stringify(param)).then(res1=>{
        console.log("-----------res1",JSON.stringify(res1))
        let retCode = res1.retCode;
        if (1 == retCode) { //success
    		if(type == 1){// 微信支付
    			let obj = res1.obj;
    			let signType = "MD5";
    			let packageStr = obj.prepayId;
    			// 使用uni-app的支付接口
    			uni.requestPayment({
    			    timeStamp: obj.timeStamp,
    			    nonceStr: obj.nonceStr,
    			    package: packageStr,
    			    signType: signType,
    			    paySign: obj.paySign,
    			    success: function (res) {
    			        // 支付成功后的回调函数
    			        callBackSuccess(res1);
    			    },
    			    fail: function (errorRes) {
    			        //失败
    			        callBackFail(errorRes);
    			    }
    			});
    		}else if(type == 2){// 支付宝支付
    			let rcResult = res1.obj.rcResult
    			console.log("支付宝H5支付地址："+rcResult)
    			let result1 = rcResult.split("location.href=")[1];
    			let result2 = result1.split(";</script></body>")[0];
    			let result3 = result2.slice(1, -1)
    			console.log("-----------------解析后支付宝支付地址："+result3)
    			// #ifdef APP-PLUS
    			  plus.runtime.openURL(result3); // 5+ API（旧版）
    			  // #endif
    			  // #ifdef H5
    				location.href = result3;
    			  // #endif
    		}
        } else {
            fnShowErrorToast(res1.retMsg);
        }
    })
}

/**
 * 消息提示框：错误提示
 */
const fnShowErrorToast = title => {
    uni.showToast({
        title: title,
        icon: 'none',
        mask: true,
        complete: function () {
            setTimeout(function () {
                uni.hideLoading()
            }, 2000);
        }
    });
}

/**
 * 跳转到选项卡中的页面
 */
const fnSwitchTab = url => {
    uni.switchTab({
        url: url
    });
}

/**
 * 当字符串 超过长度length时 用...代替后面的数据
 */
const fnGetSubString = (str, length) => {
    if (0 != str && (str == null || str == "")) {
        return "";
    }
    if (str.length > length) {
        return str.substr(0, parseInt(length)) + "...";
    }
    return str;
}

/**
 * 判断字符串是否为空
 */
const fnIsNull = (str) => {
    if (str == undefined || str == null || str == '' || str == "null") {
        return true;
    } else {
        return false;
    }
}

const fnNvl = (str, rep) => {
    if (str == undefined || str == null || str == '' || str == "null") {
        return rep;
    } else {
        return str;
    }
}

/**
 * 确认框
 * @param {*} title
 * @param {*} successCallBack
 * @param {*} falseCallBack
 */
function fnConfirm(title, successCallBack, falseCallBack) {
    uni.showModal({
        title: '提示',
        content: title,
        success: function (res) {
            if (res.confirm) {
                successCallBack()
            } else if (res.cancel) {
                falseCallBack()
            }
        }
    });
}

/**
 * 打电话
 * str 电话号
 */
const fnPhoneCall = (str) => {
    uni.makePhoneCall({
        phoneNumber: str,
    });
}

/**
 * 保留2位小数，如：2，会在2后面补上00.即2.00  3.145 = 3.15  3.144 = 3.14
 * xb
 */
function fnToDecimal(x) {
    if (x == null || x == undefined) {
        return "0.00";
    }
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}

/**
 * 分转元，除100
 */
function fnNullToEmptyMoney(str) {
    if (str == null || str == "null") {
        return "0.00";
    }
    return fnToDecimal(parseInt(fnNullToEmptyNum(str)) / 100);
}

/**
 * 判断页面数据是否为空,为空返回 "",不为空返回val
 * @param val
 */
function fnCheckNullToEmpty(val) {
    if (val != null && val != "" && val != 'null' && val != undefined) {
        return val;
    }
    return "";
}

/**
 * 将NULL转为0
 */
function fnNullToEmptyNum(str) {
    if (str == null || str == "null") {
        return "0";
    }
    return str;
}

//加法
function fnAdd(num1, num2) {
    var r1, r2, m;
    try { r1 = num1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = num2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2))
    return (num1 * m + num2 * m) / m
}

//减法
function fnSub(num1, num2) {
    return fnAdd(num1, -num2);
}

//乘法
function fnMul(num1, num2) {
    var m = 0, s1 = num1.toString(), s2 = num2.toString();
    try { m += s1.split(".")[1].length } catch (e) { }
    try { m += s2.split(".")[1].length } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//除法
function fnDiv(num1, num2) {
    var t1 = 0, t2 = 0, r1, r2;
    try { t1 = num1.toString().split(".")[1].length } catch (e) { }
    try { t2 = num2.toString().split(".")[1].length } catch (e) { }
    r1 = Number(num1.toString().replace(".", ""))
    r2 = Number(num2.toString().replace(".", ""))
    return (r1 / r2) * Math.pow(10, t2 - t1);

}

/**
 * 保留当前页面，跳转到应用内的某个页面
 */
const fnNavigateTo = url => {
    uni.navigateTo({
        url: url
    })
}

/**
 * 验证是否为手机号码
 * @param value
 * @returns
 */
const fnCheckPhoneNumber = (str) => {
    var reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
    if (!(reg.test(str))) {
        return false;
    } else {
        return true;
    }
}

/**
 * 18位身份证号码正则校验
 * @param value
 * @returns
 */
const fnCheckIDNumber = (str) => {
    var reg = /^[1-9](\d{5})(19|20)(\d{2})((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)(\d{3})(\d|X|x)$/;
    if (!(reg.test(str))) {
        return false;
    } else {
        return true;
    }
}

/**
 * 整数或者最多两位小数
 */
function handleInput(e) {
    let price = e.detail.value;
    price = price.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
    price = price.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    price = price.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    price = price.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
    if (price.indexOf(".") < 0 && price != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        price = parseFloat(price);
    }

    return price;
}

/**
 * 页面重定向
 * @param {*} url
 */
function fnRedirectTo(url) {
    uni.redirectTo({
        url: url
    });
}

/**
 * 确认框
 * @param {*} title 标题
 * @param {*} content 提示文字
 * @param {*} successCallBack 成功回调
 */
function fnShowModal(title, content, successCallBack) {
    uni.showModal({
        title: title,
        content: content,
        showCancel: true,//是否显示取消按钮
        success: function (res) {
            if (!res.cancel) {
                successCallBack();
            }
        },
        fail: function (res) {
        },
    })
}

/**
 * 确认框
 * @param {*} title 标题
 * @param {*} content 提示文字
 * @param {*} successCallBack 成功回调
 * @param {*} failCallBack  失败回调
 */
function fnShowModalNew(title, content, successCallBack, failCallBack) {
    uni.showModal({
        title: title,
        content: content,
        showCancel: true,//是否显示取消按钮
        success: function (res) {
            if (!res.cancel) {
                successCallBack();
            }else{
                failCallBack();
            }
        },
        fail: function (res) {
        },
    })
}

/**
 * 生成uuid
 */
function fnUUID() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}


/**
 * 功能：输入框只能输入数字
 * val：文本框对象
 * type：类型，1---只能输入大于0整数，2---只能输入大于等于0的数字(包括小数)
 3---只能输入大于等于0整数，4---只能输入两位数字
 6--只能输入正数、负数和0
 */
function inputCheck(val, type){
    if (type == 1) {
        if(val.length==1){
            val=val.replace(/[^1-9]/g,'');
        } else {
            val = parseInt(val);
            if(val.length==1){
                val=val.replace(/[^1-9]/g,'');
            }else{
                val=val.replace(/\D/g,'');
            }
        }
    }else if(type == 2)  {
        val = val.replace(/[^\d.]/g,"");
        //必须保证第一位为数字而不是.
        val = val.replace(/^\./g,"");
        //保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g,".");
        //保证.只出现一次，而不能出现两次以上
        val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        //两位小数
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两位小数
    }else if(type == 3)  {
        if(val.length==1){
            val=val.replace(/[^0-9]/g,'');
        } else {
            val=val.replace(/\D/g,'');
        }
    }else if(type == 4)  {
        val = val.replace(/[^\d.]/g,"");
        //必须保证第一位为数字而不是.
        val = val.replace(/^\./g,"");
        //保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g,".");
        //保证.只出现一次，而不能出现两次以上
        val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        //两位小数
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两位小数
    }else if(type == 5)  {
        val = val.replace(/[^\d.]/g,"");
        //必须保证第一位为数字而不是.
        val = val.replace(/^\./g,"");
        //保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g,".");
        //保证.只出现一次，而不能出现两次以上
        val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        //两位小数
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两位小数
    }else if(type == 6)  {
        //得到第一个字符是否为负号
        var t = val.charAt(0);
        val = val.replace(/[^\d.]/g,"");
        //必须保证第一位为数字而不是.
        val = val.replace(/^\./g,"");
        //保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g,".");
        //保证.只出现一次，而不能出现两次以上
        val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        //两位小数
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两位小数
        //如果第一位是负号，则允许添加
        if(t == '-'){
            val = '-'+val;
        }
    }
    return val;
}



/**
 * 两个数字相乘返回基
 * @param val1
 * @param val2
 */
function mulTwoValue(num1,num2) {
    var m=0,s1=num1.toString(),s2=num2.toString();
    var length = s1.split(".").length;
    if(length > 1){
        m+=s1.split(".")[1].length;
    }
    length = s2.split(".").length;
    if(length > 1){
        m+=s2.split(".")[1].length;
    }
    var pow = 10;
    for(var i=1;i<m;i++){
        pow = pow * 10;
    }
    var r =  (parseFloat(s1.replace(".","")) * parseFloat(s2.replace(".","")))/pow;
    return r;
}



/**
 * 单品佣金金额新
 * @param suitType  佣金类型 1元 2百分比
 * @param awardNum  佣金金额/百分比
 * @param awardMoney  佣金金额 （佣金类型比例时 存折算后的金额）
 * @param selfPurchaseRate 等级比例
 */
function fnGetMembChiefGradeNew2(suitType, awardNum, awardMoney, selfPurchaseRate) {
    selfPurchaseRate = !fnIsNull(selfPurchaseRate) ? selfPurchaseRate : 0;
    if(suitType == 1){
        var award = mulTwoValue(awardNum, selfPurchaseRate);
        award = fnToDecimal(award);
        return award;
    }else if(suitType == 2){
        var award = mulTwoValue(awardMoney, selfPurchaseRate);
        award = fnToDecimal(award);
        return award;
    }

    return 0;
}

/**
 * 订阅消息授权
 * templateIds  list 例：["11","22","33"],最多三个模板id
 * @param title
 */
function fnRequestSubscribeMessage(templateIdList, successFn, failFn) {
    // 判断手机微信版本是否支持uni.requestSubscribeMessage接口
    if (uni.requestSubscribeMessage) {
        // Promise函数同步调用，解决ios部分机型不支持该接口   --yaoxm 2019-12-18
        return new Promise((resolve, reject) => {
            uni.requestSubscribeMessage({
                // tmplIds: [fnGetTemplateId1()],
                tmplIds: templateIdList,
                success: res => {
                    console.log("__订阅消息授权success=" + JSON.stringify(res));
                    if (successFn) {
                        successFn(res);
                    }
                },
                fail: res => {
                    console.log("__订阅消息授权fail=" + JSON.stringify(res));
                    if (failFn) {
                        failFn(res);
                    }
                }
            })
        })
    }
    else {
        // 如果希望用户在最新版本的客户端上体验您的小程序，可以这样子提示
        confirm(
            "当前微信版本低，订阅消息功能无法使用，请升级到最新微信版本后重试。",
            function () {
                if (successFn) {
                    successFn();
                }
            },
            function () {
                if (failFn) {
                    failFn();
                }
            }
        )
    }
}

/*保留小数 四舍五入 */
function moneySwitch(money, precision) {//precision是需要精确的位数，如百分位就是2
    if (money == undefined || isNaN(money))
        return "";
    var symbol = 1
    if (money < 0) {
        // 符号为负
        symbol = -1
        money *= -1
    }
    var num2 = (Math.round(money * Math.pow(10, precision))
        / Math.pow(10, precision) + Math.pow(10, -(precision + 1)))
        .toString().slice(0, -1)
    return parseFloat(num2 * symbol).toFixed(precision)
}
/**
 * 手机号校验
 * @param {*} str
 */
function fnCheckPhone(str) {
    // let regExp = /^1(3[0-9]|4[5-79]|5[0-35-9]|6[2-7]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
    // 以1开头，第二位是3-9，后面跟9位数字
    let regExp = /^1[3-9]\d{9}$/;
    if (regExp.test(str)) {
        return true;
    } else {
        fnShowErrorToast('请输入正确的手机号');
        return false;
    }
}
function fnMD5 (str) {

}

/***
 * px转成rpx   计算宽度  高度  固定的图片导航 其他需要计算的位置 fnPxToRpxNew
 *
 * type：1计算宽度  2计算高度
 * lastWidth：PC装修完的最终显示 宽度
 * lastHeight：PC装修完的最终显示 高度
 * pmWidth:窗口宽度
 * showType：图片组件类型 0 固定图片导航 20 横向滑动图片导航 1：一行一个  2：一行2个  3：一行三个  4：轮播海报
 * marginLeftRight：页面边距（左右）
 * imgMarginLeftRight：图片边距（左右）
 * isPadding：填充方式（0 不留白   1周边留白   ）---仅轮播有值
 * imgNum : 仅图片导航有数量   ：  图片数量
 */
function fnPxToRpxPicNav(type, lastWidth, lastHeight, pmWidth, showType, marginLeftRight, imgMarginLeftRight, isPadding, imgNum) {
    var rpxBl = 750 / pmWidth;
    var pmWidthLastWidthBl = 1;

    //固定的图片导航
    //宽度比例          = ((手机屏幕宽度 - (图片间距*一行几个间隙数（一行2个有1个间隙）) - 页面边距)/一行图片数)/图片真实高度
    pmWidthLastWidthBl = Math.round((((pmWidth - (fnCheckNullForRetZero(imgMarginLeftRight) * parseInt(imgNum + 4))) / (imgNum + 4)) / fnToDecimal(fnCheckNullForRetZero(lastWidth))) * 100) / 100;

    var returnLastWidth = Math.round(lastWidth * pmWidthLastWidthBl * rpxBl * 100) / 100;
    if (showType == 20 && returnLastWidth < 75 * rpxBl) { //横向滚动的图片导航
        returnLastWidth = 75 * rpxBl;
    }
    return returnLastWidth; //实际显示宽度

}
/** * 判断系统背景颜色是否为白色
 */
function fnCheckSysColor(val) {
    var color = 'white';
    if (val == '#ffffff' || val == 'ffffff' || val == '#fff' || val == 'fff') {
        color = 'black';
    }
    return color;
}
function fnRefundType(state){
    if(state == 0){
        return '仅退款'
    }else if(state == 1){
        return '退货退款'
    }else{
        return '换货'
    }

}
/**
 * 获取整数部分
 */
function fnGetNumber(str){
    if(str==null || str==undefined){
        return "0";
    }
    if (str.toString().indexOf(".") == -1) {
        return str.toString();
    }
    return str.toString().split(".")[0];
}

/**
 * 获取小数部分
 */
function fnGetDemical(str) {
  if(str==null || str==undefined){
      return "00";
  }
  if (str.toString().indexOf(".")==-1){
    return "00";
  }
  return str.toString().split(".")[1];
}

/**
 * 数字转整数 如 100000 转为10万
 * @param {需要转化的数} num
 * @param {需要保留的小数位数} point
 */
function tranNumber(num, point) {
    var numStr = num.toString()
    //万以内直接返回
    if (numStr.length < 5) {
        return numStr;
    }else{
        var decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万';
    }
}

/**
 * 判断页面数据是否为空,为空返回 "",不为空返回val
 * @param val
 */
function fnCheckNullAndSetValue(val,val2) {
    if (val != null && val != "" && val != 'null' && val != undefined) {
        return val;
    }
    return val2;
}

/**
 * 判断页面数据是否为空，为空返回0
 * @param val
 */
function fnCheckNullForRetZero(val) {
    if (val != null && val != "" && val != 'null' && val != undefined) {
        return val;
    }
    return 0;
}

/**
 * 解决图片地址 \ 转换成  / 的问题，因为路径含 \ ,图片不显示
 * @param str
 */
function fnReplaceFxg(str) {
    return str.replace(getRegExp('\\', 'g'), "\/");
}

/***
 * px转成rpx
 * pxVal：图片要显示的宽度   或  高度
 * pmWidth:窗口宽度
 */
function fnPxToRpx(pxVal, pmWidth) {
    //console.log("真是高度或宽度：" + pxVal + "~~~" + pmWidth);
    return (pxVal * fnToDecimal(750 / pmWidth));
}
/***
 * px转成rpx   计算宽度  高度
 *
 * type：1计算宽度  2计算高度
 * lastWidth：PC装修完的最终显示 宽度
 * lastHeight：PC装修完的最终显示 高度
 * pmWidth:窗口宽度
 * showType：图片组件类型 0 固定图片导航 20 横向滑动图片导航 1：一行一个  2：一行2个  3：一行三个  4：轮播海报
 * marginLeftRight：页面边距（左右）
 * imgMarginLeftRight：图片边距（左右）
 * isPadding：填充方式（0 不留白   1周边留白   ）---仅轮播有值
 * imgNum : 仅图片导航有数量   ：  图片数量
 */
function fnPxToRpxNew(type, lastWidth, lastHeight, pmWidth, showType, marginLeftRight, imgMarginLeftRight, isPadding, imgNum) {
    var rpxBl = 750 / pmWidth;
    var pmWidthLastWidthBl = 1;
    // console.log(showType + "~~" + pmWidth + "~~" + fnCheckNullForRetZero(imgMarginLeftRight) + "~~" + fnCheckNullForRetZero(marginLeftRight) + "~~" + fnToDecimal(fnCheckNullForRetZero(lastWidth)));
    //other.showType:  0图片导航  1一行一个图  2一行两个图  3一行三个图   4轮播图
    if (showType == 2 || showType == 3) { //一行2个   //一行3个
        //宽度比例          = ((手机屏幕宽度 - (图片间距*一行几个间隙数（一行2个有1个间隙）) - 页面边距)/一行图片数)/图片真实高度
        pmWidthLastWidthBl = Math.round((((pmWidth - (fnCheckNullForRetZero(imgMarginLeftRight) * (parseInt(showType) + 1)) - (fnCheckNullForRetZero(marginLeftRight) * 2)) / showType) / fnToDecimal(fnCheckNullForRetZero(lastWidth))) * 100) / 100;
    } else if (showType == 1 || showType == 4) { //轮播图
        //宽度比例 = (手机屏幕宽度  - 页面边距)/图片真实高度
        pmWidthLastWidthBl = Math.round(((pmWidth - (fnCheckNullForRetZero(imgMarginLeftRight) * 2) - (fnCheckNullForRetZero(marginLeftRight) * 2)) / fnToDecimal(fnCheckNullForRetZero(lastWidth))) * 100) / 100;
    } else if (showType == 0) { //固定的图片导航
        //宽度比例          = ((手机屏幕宽度 - (图片间距*一行几个间隙数（一行2个有1个间隙）) - 页面边距)/一行图片数)/图片真实高度
        pmWidthLastWidthBl = Math.round((((pmWidth - (fnCheckNullForRetZero(imgMarginLeftRight) * parseInt(imgNum))) / imgNum) / fnToDecimal(fnCheckNullForRetZero(lastWidth))) * 100) / 100;
    } else if (showType == 20) { //横向滚动的图片导航
        //宽度比例          = ((手机屏幕宽度 - (图片间距*一行几个间隙数（一行2个有1个间隙）) - 页面边距)/一行图片数)/图片真实高度
        pmWidthLastWidthBl = Math.round((((pmWidth - (fnCheckNullForRetZero(imgMarginLeftRight) * parseInt(imgNum)) - 35) / imgNum) / fnToDecimal(fnCheckNullForRetZero(lastWidth))) * 100) / 100;
    }
    if (type == 1) {
        var returnLastWidth = Math.round(lastWidth * pmWidthLastWidthBl * rpxBl * 100) / 100;
        if (showType == 20 && returnLastWidth < 75 * rpxBl) { //横向滚动的图片导航
            returnLastWidth = 75 * rpxBl;
        }
        return returnLastWidth; //实际显示宽度
    } else {
        var returnLastHeight = Math.round(lastHeight * pmWidthLastWidthBl * rpxBl * 100) / 100;
        var returnLastWidth = Math.round(lastWidth * pmWidthLastWidthBl * rpxBl * 100) / 100;
        var returnLastWidthNew = returnLastWidth;

        if (showType == 20 && returnLastWidth < 75 * rpxBl) { //横向滚动的图片导航
            returnLastWidth = 75 * rpxBl;
            returnLastWidthNew = returnLastWidth - returnLastWidthNew;
            returnLastHeight = returnLastHeight + returnLastWidthNew;
            // console.log("横向滚动：returnLastWidth=" + returnLastWidth + ",returnLastWidthNew=" + returnLastWidthNew + ",returnLastHeight=" + returnLastHeight);
        }

        return returnLastHeight; //实际显示高度
    }
}



/**
 * 保留2位小数（不补0），如：2，即2  3.145 = 3.15  3.1 = 3.1
 * xb
 */
function fnToDecimalNoCover(x) {
    if (x == null || x == undefined) {
        return "0.00";
    }
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        // s += '.';
    }
    // while (s.length <= rs + 2) {
    //   s += '0';
    // }
    return s;
}

/**
 * 获取绝地址
 */
function fnAbsNum(x) {
    return Math.abs(x);
}

/**
 * 拼接图片地址
 * @param str 图片服务器地址
 */
 function fnImgRequestPath(str){
    if (str == null || str == "") {
        return "";
    }
    if(str.indexOf('https') != '-1'){
        return str;
    }
    if(str.indexOf('http') != '-1'){
        return str;
    }
    return toolsActive+ str;
}

/** * 判断页面数据是否为空
 */
function fnCheckNull(val) {
    var flg = false;
    if (val != null && val != "" && val != 'null' && val != undefined && val != 'undefined') {
        flg = true;
    }
    return flg;
}

/**
 * 两个数值相加返回和
 */
function addTwoValue(val1, val2) {
    val1 = fnCheckNull(val1)?val1:0;
    val2 = fnCheckNull(val2)?val2:0;
    return val1 + val2;
}

/**
 * 两个数值相减返回差
 * @param val1
 * @param val2
 */
function subTwoValue(val1,val2) {
    return (val1 - val2).toFixed(2);
}


/**
 * 两个数字除返回基
 * @param val1
 * @param val2
 */
function divTwoValue(num1,num2) {
    var t1 = 0, t2 = 0, r1, r2;
    r1 = Number(num1.toString().replace(".", ""))
    r2 = Number(num2.toString().replace(".", ""))
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

/**
 * 拼接图片地址
 * @param str 图片服务器地址
 */
function fnReplaceSerImgUrl(str){
    return fnImgRequestPath(str);
}

/**
 * 拼接静态图片地址
 * @param str
 */
function fnStaticRequestPath(str){
    if (str == null || str == "") {
        return "";
    }
    return toolsStatic + str;
}

/**
 * 拼接银行卡号加密后的结果
 * @param str
 */
function fnStaticRequestEncryption(str){
    if (str == null || str == "") {
        return "";
    }
    return str.substring(0,4)+"****"+str.substring(str.length-4);
}

/**
 * 将字符串以分号分隔为一个数组
 */
function fngetArrayByString(str) {
    var arr = []
    if (str != null && str != "") {
        arr = str.split(";");
    }
    return arr;
}

/**
 *
 * @param str 将字符串已逗号分隔为一个数组
 */
function fnGetArrayByStringForComma(str) {
    var arr = []
    if (str != null && str != "") {
        arr = str.split(",");
    }
    if(fnCheckNullWithRetVal(arr[arr.length-1])==''){
        arr.splice((arr.length-1), 1);
    }
    return arr;
}

/**
 * 格式化字符串，字符串长度大于len，则截取，其余字符用...替换
 */
function fnFormatStr(str, len) {
    if (len != null && len != "" && len != undefined) {
        if (str != null && str.length > len) {
            return str.substring(0, len) + "...";
        } else {
            return str;
        }
    } else {
        return str;
    }
}

/**
 * 时间格式化
 * @param s 时间
 * @param t 返回时间类型
 *          0、 月.日 例：6.11
 *          1、 年/月/日 例：2020/06/17
 */
function fnFormarDate(s,t){
    var str = "";
    if(t == 0){
        s = s.substring(0,10);
        str = parseInt(s.split("-")[1]) + "." + s.split("-")[2];
    }else if(t == 1){
        s = s.substring(0,10);
        str = s.replace(getRegExp('-','g'),"/")
    }
    return str;
}
/**
 * 时间转换
 */
function formatTime(value) {
    var valList = value.split("-");
    var val = valList[0] + "/" + valList[1] + "/" + valList[2];
    var now = getDate();
    var time = getDate(val);
    var timeLen = now - time;
    var day = timeLen / 86400000;
    var hour = timeLen / 3600000;
    var minute = timeLen / 60000;
    // console.log(parseInt(hour));
    var returnStr = "";
    if (day >= 7) {
        returnStr = "一个星期前";
    } else if (day >= 1) {
        returnStr = parseInt(day) + "天前";
    } else if (hour >= 1) {
        returnStr = parseInt(hour) + "小时前";
    } else if (minute >= 1) {
        returnStr = parseInt(minute) + "分钟前";
    } else {
        returnStr = "刚刚";
    }
    return returnStr;
}
/** 获取商品虚拟库存*/
function fnGetProdStock(list){
    var num = 0;
    for(var i = 0; i < list.length; i ++){
        var obj = list[i];
        num = parseFloat(num) + parseFloat(obj.virtualNum);
    }
    return num;
}
/**
 * 截取 超过20个字符显示点点点
 */
function fnSubstring(str){
    if(str.length >10){
        return str.substring(0,10) + "...";
    }else{
        return str;
    }
}

/**
 * 处理数字：千位符、保留小数位数
 * @param num 值
 * @param del 小数位
 * @param o o为true返回值为正数,否则为负数
 * @returns {String}
 */
function RetainedDecimalPlaces(num, del, o) {

    num += "";
    //num = _round(parseFloat(num),del)+""; //保留小数并四舍五入
    var str = "";
    //清除字符串中的非数字 非.字符
    //var str = 'q1w2e3'
    //var result = str.replace(getRegExp('\d+', 'img'),0)
    num = num.replace(getRegExp('/[^0-9|\.]/g','g'), "");

    //清除字符串开头的0
    if (getRegExp('/^0+/','g')) num = num.replace(getRegExp('/^0+/','g'), "");

    //为整数字符串在末尾添加.0000
    if (!getRegExp('/\./','g').test(num)) num += ".0000";
    //字符以.开头时，在开头添加0
    if (getRegExp('/^\./','g').test(num)) num = "0" + num; num += "0000"; //在字符串末尾补零

    if (del == 2){
        num = num.match(getRegExp('/\d+\.\d{3}/','g'))[0];
    }
    if (del == 4) {
        num = num.match(getRegExp('/\d+\.\d{4}/','g'))[0];
    }

    var num1 =mulTwoValue(num,1000);

    var num2= num1/10;

    var num3 = Math.round(num2);
    var num4= num3/100;

    num = num4;

    num = _round(parseFloat(num),del)+"";
    //千位符
    while (getRegExp('/\d{4}(\.|,)/','g').test(num)) //符合条件则进行替换
        num = num.replace(getRegExp('/(\d)(\d{3}(\.|,))/','g'), "$1,$2"); //每隔3位添加一个
    return str + num;

}

/**
 *格式化数据
 */
function _round(value, num) {
    var a, b, c, i;
    a = value.toString();
    b = a.indexOf(".");
    c = a.length;
    if (num == 0) {
        if (b != -1) {
            a = a.substring(0, b);
        }
    } else {
        if (b == -1) {
            a = a + ".";
            for (i = 1; i <= num; i++) {
                a = a + "0";
            }
        } else {
            a = a.substring(0, b + num + 1);
            for (i = c; i <= b + num; i++) {
                a = a + "0";
            }
        }
    }
    return a;
}

function fnGetChangeName(changeType,orderNo, remark) {
	var str='';
	if (changeType==1101){
		str="手动增加消费积分";
	} else if (changeType == 1201) {
		str="手动减少消费积分";
	} else if (changeType == 1102) {
		str="健康优库订单支付";
	} else if (changeType == 1202) {
		str="健康优库订单退款";
	} else if (changeType == 1103) {
		str="奖励转消费积分";
	} else if (changeType == 2101) {
		str="手动增加奖励积分";
	} else if (changeType == 2201) {
		str="手动减少奖励积分";
	} else if (changeType == 2102) {
		str="悦享专区订单退款";
	} else if (changeType == 2202) {
		str="悦享专区订单支付";
	} else if (changeType == 2103) {
		str="健康优库订单退款";
	} else if (changeType == 2203) {
		str="健康优库订单支付";
	} else if (changeType == 2104) {
		str="提现失败";
	} else if (changeType == 2204) {
		str="提现扣除";
	} else if (changeType == 2105) {
		str="获得赠送奖励积分";
	} else if (changeType == 2205) {
		str="赠送奖励积分扣除";
	} else if (changeType == 2106) {
		str="奖励抵扣增加";
	} else if (changeType == 2206) {
		str="奖励抵扣减少";
	} else if (changeType == 2108) {
		str="充值增加";
	} else if (changeType == 2208) {
		str="充值退款减少";
	} else if (changeType == 2107) {
		str="兑换专区订单退款";
	} else if (changeType == 2207) {
		str="兑换专区订单支付";
	}

	else if (changeType == 2111) {
		str="悦享专区分享奖";
	} else if (changeType == 2112) {
		str="悦享专区销售奖";
	} else if (changeType == 2113) {
		str="悦享专区感恩奖";
	} else if (changeType == 2114) {
		str="悦享专区培育奖";
	} else if (changeType == 2115) {
		str="悦享专区活跃奖";
	} else if (changeType == 2116) {
		str="健康优库销售奖";
	} else if (changeType == 2117) {
		str="健康优库荣誉平级奖";
	} else if (changeType == 2118) {
		str="健康优库董事分红";
	} else if (changeType == 2119) {
		str="健康优库董事分红平级奖";
	}

	else if (changeType == 3101) {
		str="手动增加兑换积分";
	} else if (changeType == 3201) {
		str="手动减少兑换积分";
	} else if (changeType == 3102) {
		str="订单支付";
	} else if (changeType == 3202) {
		str="订单退款";
	} else if (changeType == 3103) {
		str="奖励转兑换积分";
	} else if (changeType == 3104) {
        str="报单赠送";
    } else if (changeType == 3204) {
        str="报单退单扣除";
    }

	if(orderNo != null && orderNo != ""){
		str +="，订单号：" + orderNo;
	}

	if(remark != null && remark != ""){
		str +="，" + remark;
	}
	return str;
}

function fnGetAwardRecordName(splitType, orderNo, remark) {
	var str = '';
	if (splitType == 11) {
		str = "悦享专区分享奖";
	} else if (splitType == 12) {
		str = "悦享专区销售奖";
	} else if (splitType == 13) {
		str = "悦享专区感恩奖";
	} else if (splitType == 14) {
		str = "悦享专区培育奖";
	} else if (splitType == 15) {
		str = "悦享专区活跃奖";
	} else if (splitType == 16) {
		str = "悦享专区董事分红";
	} else if (splitType == 21) {
		str = "健康优库销售奖";
	} else if (splitType == 22) {
		str = "健康优库董事分红";
	} else if (splitType == 23) {
		str = "健康优库荣誉平级奖";
	} else if (splitType == 24) {
		str = "健康优库董事平级奖";
	}

	if (orderNo != null && orderNo != "") {
		str += "，订单号：" + orderNo;
	}

	if (remark != null && remark != "") {
		str += remark;
	}
	return str;
}

function abs(changeMoney){
	return Math.abs(changeMoney);
}

export {
    fnCheckNullForRetZero,
    fnReplaceFxg,
    fnPxToRpx,
    fnPxToRpxNew,
    fnToDecimalNoCover,
    fnAbsNum,
    fnImgRequestPath,
    fnCheckNull,
    addTwoValue,
    tranNumber,
    fnGetNumber,
	fnGetDemical,
    fnReplaceSerImgUrl,
    fnStaticRequestPath,
    fnStaticRequestEncryption,
    fngetArrayByString,
    fnShowToast,
    RetainedDecimalPlaces,
    _round,
    fnSubstring,
    divTwoValue,
    fnGetArrayByStringForComma,
    fnFormarDate,
    formatTime,
    fnCheckNullAndSetValue,
    fnGetProdStock,
    fnFormatStr,
    subTwoValue,
    mulTwoValue,
    fnCheckSysColor,
	fnRefundType,
	fnCheckPhone,
	fnShowSuccessToast,
	fnShowErrorToast,
	fnSwitchTab,
	fnGetSubString,
	fnIsNull,
	fnConfirm,
	fnPhoneCall,
	fnPxToRpxPicNav,
	fnToDecimal,
	fnNullToEmptyMoney,
	fnNullToEmptyNum,
	fnAdd,
	fnSub,
	fnMul,
	fnDiv,
	fnCheckNullToEmpty,
	fnNavigateTo,
	fnCheckPhoneNumber,
	fnCheckIDNumber,
	handleInput,
	fnRedirectTo,
	fnShowModal,
	fnShowModalNew,
	fnUUID,
	inputCheck,
	fnGetMembChiefGradeNew2,
	fnRequestSubscribeMessage,
	moneySwitch,
	fnMD5,
	fnNvl,
    fnGetChangeName,
    abs,
    fnGetAwardRecordName,
    fnOrderPayByHj,
	fnOrderPayThirdParty,
	fnOrderPayThirdPartyRecharge
}